import { BaseApiUrl } from '../../../configVariables';
import { ReportingMetricsRangeComparison } from '../../../model/ReportingMetrics';
import apiClient from '../../../utils/apiClient';

export type ReportingMetricsRequest = {
    readonly utcStartDate: string;
    readonly utcEndDate: string | null;
    readonly aircraftRegNumber: string | null;
    readonly category: string | null;
    readonly groundTeamId: string | null;
};

export const fetchReportingMetrics = async (
    request: ReportingMetricsRequest
) => {
    return apiClient.get<ReportingMetricsRangeComparison>(
        `${BaseApiUrl}/reportingMetrics`,
        { query: request }
    );
};
